module.exports = __webpack_public_path__ + "img/marker-food.36e93b28.png";